export const STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const STATUS_RELEASED = 'RELEASED';
export const STATUS_LOCKED = 'LOCKED';

export const KPI_SYSTEM_STATUSES = [STATUS_IN_PROGRESS, STATUS_RELEASED, STATUS_LOCKED];

export const GROUPING_TYPE_CATEGORY = "CATEGORY";
export const GROUPING_TYPE_CRITERION = "CRITERION";
export const GROUPING_TYPE_KPI = "KPI";
